module.exports = __webpack_public_path__ + "img/userComment.30d8ec87.svg";